export enum FlashcardType {
  QuestionAnswer = 'QuestionAnswer',
  MultipleChoice = 'MultipleChoice',
  TrueFalse = 'TrueFalse',
  Ordering = 'Ordering',
  MultiBlankChoice = 'MultiBlankChoice',
  Matching = 'Matching'
}

export interface Flashcard {
  cardId: string;
  sourceCardId?: string;
  sourceDeckId?: string;
  sourceDeckName?: string;
  type: FlashcardType;
  question: string;
  answer?: string;
  choices?: string[];
  choiceGroups?: string[][];
  correctChoiceIndex?: number;  // Deprecated, use correctChoiceIndices
  correctChoiceIndices?: number[];  // Preferred for multiple correct answers
  correctChoiceGroupIndices?: number[];
  imageUrl?: string;  // Optional reference image (e.g., dive tables, diagrams)
  hint?: string;  // Optional hint that can be revealed during study
}

export type FlashcardDeckGroup = 'topics' | 'certifications';

export interface FlashcardDeck {
  userId?: string;  // Optional: tracks who last modified this global deck
  deckId: string;
  deckName: string;
  group?: FlashcardDeckGroup;
  iconUrl?: string;  // Optional icon URL or icon name for deck
  cards: Flashcard[];
  createdAt: string;
  updatedAt: string;
}

export interface ParseFlashcardsRequest {
  content: string;
  contentType?: string;
}

export interface ParseFlashcardsResponse {
  cards: Flashcard[];
  count: number;
}

export enum JobStatus {
  Pending = 'Pending',
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed'
}

export interface ProcessingJob {
  jobId: string;
  userId: string;
  jobType: string;
  status: JobStatus;
  errorMessage?: string;
  createdAt: string;
  updatedAt: string;
  resultData?: string;
  metadata?: Record<string, string>;
}

export interface AsyncJobResponse {
  jobId: string;
  status: string;
}

export interface RecordAnswerRequest {
  userId: string;
  deckId: string;
  cardId: string;
  isCorrect: boolean;
}

export interface FlashcardStatsResponse {
  cardStats: Record<string, CardStat>;
}

export interface CardStat {
  incorrectCount: number;
}
